import { Tag, type TableColumnsType } from 'antd';
import { CatalogueRowActions } from '../../../../../shared/components/CatalogueRowActions';
import type { CatalogueRowHandlers } from '../../../components/CataloguePanel';
import type { WeightBand } from '../../../reference-data.api';

export function buildWeightBandColumns({ onEdit, onDeactivate, onReactivate }: CatalogueRowHandlers<WeightBand>): TableColumnsType<WeightBand> {
  return [
    { title: 'Code', dataIndex: 'code', key: 'code', render: (code: string) => <span className="font-mono text-xs">{code}</span> },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Min kg', dataIndex: 'minKg', key: 'minKg', align: 'right', render: (minKg: number) => minKg.toLocaleString('en-KE') },
    {
      title: 'Max kg',
      dataIndex: 'maxKg',
      key: 'maxKg',
      align: 'right',
      render: (maxKg: number | null) => (maxKg === null ? <span className="text-muted">No upper limit</span> : maxKg.toLocaleString('en-KE')),
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: boolean) => <Tag color={isActive ? 'success' : 'default'}>{isActive ? 'Active' : 'Inactive'}</Tag>,
    },
    {
      title: '',
      key: 'actions',
      render: (_, row) => <CatalogueRowActions row={row} onEdit={onEdit} onDeactivate={onDeactivate} onReactivate={onReactivate} />,
    },
  ];
}
